enum AuthenticationCodeSendingTypeEnum {
  SMS = 'S',
  Email = 'E',
}

export default AuthenticationCodeSendingTypeEnum
